import React from 'react';
export const SettingResetPassword = React.lazy(() => import('./SettingResetPassword.jsx'));
